module.exports = __webpack_public_path__ + "static/media/Plan01.8f000168.png";